module.exports = __webpack_public_path__ + "static/img/14.afcdf7a9.png";